import {getAppState} from "../helpers/tools";
import ActionValidator from "../helpers/ActionValidator";
import Worker from "worker-loader!../workers/notifications.worker.js";

/**
 *
 * @param action
 * @returns {Function}
 */
export const setAction = (action) => {
  return dispatch => {
    dispatch({type: "SET_ACTION", data: action});
  }
};

/**
 *
 * @param action
 * @returns {Function}
 */
export const takeAction = (action) => {
  return (dispatch, getState) => {
    dispatch({type: "TAKE_ACTION", data: action});

    const state = getAppState( getState() );
    const validation = new ActionValidator(action, state);
    if (validation.pass()) {
      dispatch({
        type: "TAKE_ACTION_FULFILLED",
        data: {
          action,
          message: validation.getSuccessMessage(),
        },
      });
      const worker = new Worker();
      worker.postMessage([state, action]);
      worker.addEventListener('message', event => {
        dispatch({
          type: "NEW_NOTIFICATIONS",
          data: event.data,
        });
      });
    } else {
      dispatch({
        type: "TAKE_ACTION_REJECTED",
        data: validation.getErrorMessage(),
      });
    }
  }
};
